import { render, staticRenderFns } from "./hole.vue?vue&type=template&id=241aa31e&scoped=true&"
import script from "./hole.vue?vue&type=script&lang=js&"
export * from "./hole.vue?vue&type=script&lang=js&"
import style0 from "./hole.vue?vue&type=style&index=0&id=241aa31e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "241aa31e",
  null
  
)

export default component.exports